module.exports = __webpack_public_path__ + "media/images/icon-checkbox2-on-59b3d332643b1932f38973ae21f19f83.svg";